import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import {CSSProperties} from "react";
import {LuGripVertical} from "react-icons/lu";

import {ColumnOption} from "@/components/columnSelector/ColumnSelector.types.ts";
import {IconButton} from "@/components/iconButton/IconButton.tsx";

import styles from "./SortableColumnItem.module.scss";

interface SortableColumnItemProps {
  col: ColumnOption;
}

export const SortableColumnItem = ({col}: SortableColumnItemProps) => {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({id: col.id});

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1 : 0,
  };

  return (
    <div ref={setNodeRef} style={style} className={styles.columnItem}>
      <IconButton
        icon={LuGripVertical}
        variant={"ghost"}
        size={"fitIcon"}
        className={styles.dragHandle}
        aria-label={`Drag to reorder ${col.label}`}
        {...attributes}
        {...listeners}
      />
      <span className={styles.columnItemLabel}>{col.label}</span>
    </div>
  );
};
